// Accueil : le balisage accepté du prototype, chargé tel quel (fragment HTML).
// À composantiser lorsque des données réelles y seront branchées.
import { Link, Meta, Title } from '@solidjs/meta';
import { useLogoTrack, useReveal } from '~/lib/mount';
import html from './fragments/home.html?raw';

export default function Home() {
  useReveal();
  useLogoTrack();
  return (
    <>
      <Title>TG3R — Distribution et logistique alimentaire au Québec</Title>
      <Meta
        name="description"
        content="TG3R est votre partenaire de confiance pour le développement commercial, la distribution et la logistique alimentaire à travers le Québec."
      />
      <Link rel="preload" as="image" href="/dock-dusk-logo.jpg" fetchpriority="high" />
      <div innerHTML={html} />
    </>
  );
}
